var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file step-horizontal组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { classPrefix } from '../../../common/util';

import './index.less';

/**
 * 参数说明
 * current          必需，当前步骤所在位置，从0开始计
 * steps            必须，整体步骤数据，length至少为2
 */

var StepsHorizontal = function (_Component) {
    _inherits(StepsHorizontal, _Component);

    function StepsHorizontal() {
        _classCallCheck(this, StepsHorizontal);

        return _possibleConstructorReturn(this, (StepsHorizontal.__proto__ || Object.getPrototypeOf(StepsHorizontal)).apply(this, arguments));
    }

    _createClass(StepsHorizontal, [{
        key: 'showStepsDiv',
        value: function showStepsDiv() {
            var _this2 = this;

            var steps = this.props.steps;
            return steps.map(function (item, idx) {
                var style = { width: 1 / steps.length * 100 + '%' };
                var className = classnames({
                    'steps-div': true
                });
                return React.createElement(
                    'div',
                    { key: idx,
                        className: className,
                        style: style
                    },
                    _this2.renderStepIcon(item, idx),
                    _this2.renderStepText(item, idx)
                );
            });
        }
    }, {
        key: 'renderStepIcon',
        value: function renderStepIcon(item, idx) {
            var _props = this.props,
                current = _props.current,
                steps = _props.steps;

            var isDoneAndisDoing = idx <= current;
            var isDoing = idx === current;
            var isDone = idx < current;
            var stepsIconCls = classnames({
                'steps-icon': true
            });
            var stepsLinesCls1 = classnames({
                'steps-lines': true,
                'steps-lines-none': idx === 0,
                'steps-lines-done': isDoneAndisDoing
            });
            var stepsLinesCls2 = classnames({
                'steps-lines': true,
                'steps-lines-none': idx === steps.length - 1,
                'steps-lines-done': isDoneAndisDoing
            });
            var stepsIconPicCls = classnames({
                'steps-icon-pic': true
            });
            var stepsIconPicInnerCls = classnames({
                'steps-icon-normal': true,
                'steps-icon-current': isDoing,
                'steps-icon-done': isDone
            });
            return React.createElement(
                'div',
                { className: stepsIconCls },
                React.createElement('div', { className: stepsLinesCls1 }),
                React.createElement('div', { className: stepsLinesCls2 }),
                React.createElement(
                    'div',
                    { className: stepsIconPicCls },
                    React.createElement(
                        'div',
                        { className: stepsIconPicInnerCls },
                        !isDone && idx + 1
                    )
                )
            );
        }
    }, {
        key: 'renderStepText',
        value: function renderStepText(item, idx) {
            var current = this.props.current;
            var isDoneAndisDoing = idx <= current;
            var isDoing = idx === current;
            var titleCls = classnames({
                'steps-title': true,
                'steps-title-done-and-doing': isDoneAndisDoing
            });
            var descriptionCls = classnames({
                'steps-description': true,
                'steps-description-doing': isDoing
            });
            return [React.createElement(
                'div',
                { key: 'title', className: titleCls },
                item.title
            ), React.createElement(
                'div',
                { key: 'description', className: descriptionCls },
                item.description
            )];
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props2 = this.props,
                className = _props2.className,
                classPrefix = _props2.classPrefix,
                steps = _props2.steps;

            if (steps.length < 2) {
                return null;
            }
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, classPrefix + '-steps-wrap', true), _classnames));
            return React.createElement(
                'div',
                { className: rootClass },
                this.showStepsDiv()
            );
        }
    }]);

    return StepsHorizontal;
}(Component);

StepsHorizontal.propTypes = {
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    current: PropTypes.number,
    steps: PropTypes.array
};
StepsHorizontal.defaultProps = {
    classPrefix: classPrefix,
    current: 0,
    steps: []
};
export default StepsHorizontal;